import React from "react";
import { useCartContext } from "../../Context/CartContext.jsx";
import { IoClose } from "react-icons/io5";
import CartProduct from "./CartProduct.jsx";
export const CartContainerMobile = () => {
  const { products, subtotal, setIsCartOpen, isCartOpen } = useCartContext();
  const handleDelete = (e) => {
    setIsCartOpen(false);
  };
  return (
    <div
      className={`${!isCartOpen ? "hidden" : ""} absolute right-0 top-0 z-[10000] flex flex-col w-[80%] max-w-[350px] h-screen bg-white shadow-[-3px_0px_0px_0px] shadow-slate-200 pb-4`}
    >
      <div
        className="absolute top-[1%] left-[1%] rounded-full"
        onClick={handleDelete}
      >
        <IoClose className="text-mariposa text-[20px] cursor-pointer" />
      </div>
      <div className="flex flex border-slate-200 gap-2 w-[100%] min-h-[90px] flex justify-center items-center">
        <span className="first-letter:text-mariposa text-[22px] text-black font-bold  font-Roboto ">
          Mariposa
        </span>
        <span className="font-RobotoSlab font-[600] text-[22px]">
          Restaurant
        </span>
      </div>
      <div className="flex-col gap-4 px-2 py-2">
        <div className="text-[20px] border-b-[1px] border-slate-200 font-Roboto font-[500] flex">
          Carrito de Compras
        </div>
        <div>
          <div className="flex flex-col w-[100%] h-[90px] border-b-[1px] border-slate-200 justify-evenly">
            <div className="text-[18px] tracking-wide font-Roboto font-[400] flex">
              {products.length} Productos
            </div>
            <div className="leading-[16px] text-[20px] text-mariposa font-Roboto font-[500] flex flex-wrap">
              <span className="text-black mr-2 font-RobotoSlab text-[20px]">
                Subtotal:{" "}
              </span>{" "}
              ${subtotal}
            </div>
          </div>
        </div>
      </div>
      <div className="overflow-y-auto flex-grow flex flex-col  bg-white last:border-b-[0px]">
        {products.map((product, index) => (
          <CartProduct product={product} />
        ))}
      </div>
    </div>
  );
};
